import { Nav, Navbar, Container, Row, Col } from "react-bootstrap";
import logo from "../images/logo.png";
import { useCallback } from "react";
import UserInfoDropdown from "./UserInfoDropdown";

export default function AuthenticatedWrapper({ user, children, style = {} }) {
  const isLoggedIn = !!user;

  const getDashboard = useCallback(() => {
    if (user?.staffUser) {
      return "#/admin/dashboard";
    }

    if (user?.localAuthorityId) {
      return "#/local-authority/dashboard";
    }

    return "#/provider/dashboard";
  }, [user]);

  return (
    <Container fluid className={"bplaced-wrapper"}>
      <Row className="bplaced-inner">
        <Navbar expand="lg" className="navbar-wrapper" style={{ flexBasis: 50 }}>
          <Container fluid>
            <Navbar.Brand href={getDashboard()}>
              <img src={logo} height={35} style={{ marginTop: 2 }} />
            </Navbar.Brand>

            <Col md={8} className={"columnRight"}>
              <Navbar.Toggle aria-controls="navbarScroll" />

              <Navbar.Collapse id="bplacedNavBar">
                <Nav className="me-auto">
                  {isLoggedIn !== true ? <Nav.Link href="#/admin">Admin</Nav.Link> : null}
                </Nav>
                {isLoggedIn && <UserInfoDropdown user={user} />}
              </Navbar.Collapse>
            </Col>
          </Container>
        </Navbar>

        <Col xs={12}>{children}</Col>
      </Row>
    </Container>
  );
}
